import { call, put, select } from 'redux-saga/effects';
import { urls } from '../../../common/urls';
import { getHttp, getHttpwithtoken, postHttpwithtoken } from '../../../common/ApiCall';
import {
  userDetailsFailure,
  userDetailsLoading,
  userDetailsSuccess,
} from '../../ducks/UsersSlice';

// User Details Handler
export function* handlerUserDetails(action: any): Generator<any, void, any> {
  try {
    yield put(userDetailsLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.getProfile}`);
    
    if (response.success) {
      yield put(userDetailsSuccess(response.data));
    } else {
      yield put(userDetailsFailure(response.message || 'Failed to get user details'));
    }
  } catch (error: any) {
    yield put(userDetailsFailure(error.message || 'Failed to get user details'));
  }
}
